import { REPORT_STATE_KEY, ReportState } from './report-reducer';

export enum REPORT_ACTION_TYPE {
  SET_REPORT_STATE = 'SET_REPORT_STATE',
  CALL_SHOP = 'CALL_SHOP',
  CALL_CONFIG_AND_SHOP_LIST = 'CALL_CONFIG_AND_SHOP_LIST'
}

export type SetReportStateAction<KeyName extends keyof ReportState> = {
  type: REPORT_ACTION_TYPE.SET_REPORT_STATE;
  payload: { key: KeyName, value: ReportState[KeyName] };
};

export type CallConfigAndShopListAction = {
  type: REPORT_ACTION_TYPE.CALL_CONFIG_AND_SHOP_LIST;
  payload: { onSuccess: () => void, onFailureCallback: () => void };
};

export type ReportActions = SetReportStateAction<REPORT_STATE_KEY> | CallConfigAndShopListAction;
